// Aviso de que los cambios del proyecto no se pudieron guardar —
// ADR-2026-11-02-el-estudio-guarda-solo-lo-ultimo-y-avisa-si-falla.
//
// Antes el guardado fallaba en silencio: la persona seguía editando un proyecto que no
// se estaba guardando y se enteraba al volver a abrirlo. Flota debajo de la barra de
// arriba, centrado (lo ubica el contenedor de avisos del editor, junto con el del clip),
// y se va solo cuando un reintento sale bien.
import { AlertCircle } from 'lucide-react';
import { useAperturaAnimada } from '../../hooks/useAperturaAnimada';

export function AvisoDeGuardado({
  fallo,
  onReintentar,
}: {
  fallo: boolean;
  onReintentar: () => void;
}) {
  const { montado, visible } = useAperturaAnimada(fallo, 150);
  if (!montado) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className={`pointer-events-auto flex items-center gap-2 rounded-full bg-white py-1.5 pl-3 pr-1.5 text-[12.5px] font-medium text-brand-black shadow-md ring-1 ring-black/[0.06] transition-[opacity,transform,filter] ease-out ${
        visible
          ? 'opacity-100 duration-300 motion-safe:translate-y-0 motion-safe:blur-0'
          : fallo
            ? // entrando: arranca 12px más abajo
              'opacity-0 duration-300 motion-safe:translate-y-3 motion-safe:blur-[4px]'
            : // saliendo: se va hacia arriba, más corto
              'opacity-0 duration-150 motion-safe:-translate-y-3 motion-safe:blur-[4px]'
      }`}
    >
      <AlertCircle className="h-4 w-4 shrink-0 text-error" aria-hidden="true" />
      <span>No se pudieron guardar los cambios. Lo seguimos intentando.</span>
      <button
        type="button"
        onClick={onReintentar}
        className="rounded-full px-3 py-1 text-[12px] font-semibold text-brand-primary transition-[background-color,transform] duration-150 ease-out hover:bg-[rgb(var(--brand-primary-rgb)_/_0.085)] active:scale-[0.96]"
      >
        Reintentar
      </button>
    </div>
  );
}
